/**
 * System
 */

import {
	extend
} from '@ifabnpm/bootstrap/utils.js';
import {
	isArray,
	isNumber
} from '@ifabnpm/bootstrap/utils/is.js';

import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

// --------
// Let's go
// --------

const DEFAULTS = {
	info : [],
	grid : 12
};

let systemSettings = null;
let systemToggle = null;
let systemSettingsInfo = null;
let systemSettingsOptions = null;
let systemGrid = null;

const buildSystem = async (options) => {
	const storageSystem = localStorage.getItem(`i-system`);

	systemSettings = Manipulator.elementAppend(`<div class="system system-settings" role="presentation"></div>`);

	const systemSettingsInner = Manipulator.elementAppend(`<div class="system system-settings__inner"></div>`, systemSettings);

	systemSettingsInfo = Manipulator.elementAppend(`<div class="system-settings-info"></div>`, systemSettingsInner);
	systemSettingsOptions = Manipulator.elementAppend(`<div class="system-settings-options"></div>`, systemSettingsInner);

	systemToggle = Manipulator.elementPrepend(`<button aria-label="Show/hide system info" aria-pressed="false" type="button" class="system-settings-toggle"></button>`, systemSettings);

	EventHandler.on(systemToggle, 'handleDisplay', (event) => {
		if (storageSystem === '1') {
			event.target.setAttribute('aria-pressed', 'true');
		} else {
			event.target.setAttribute('aria-pressed', 'false');
			localStorage.setItem(`i-system`, '0');
		}
	});

	EventHandler.on(systemToggle, 'click', (event) => {
		const pressedAttr = event.target.getAttribute('aria-pressed') ?? '';

		event.preventDefault();
		event.stopPropagation();

		if (pressedAttr === 'true') {
			event.target.setAttribute('aria-pressed', 'false');
			localStorage.setItem(`i-system`, '0');
		} else {
			event.target.setAttribute('aria-pressed', 'true');
			localStorage.setItem(`i-system`, '1');
		}
	});

	systemToggle.setAttribute('aria-pressed', `${((!storageSystem || storageSystem === '0') ? 'false' : 'true')}`);
};

const addInfo = (options) => {
	if (undefined !== options.info && isArray(options.info)) {
		for (let i = 1; i < options.info.length; i += 1) {
			if (undefined !== options.info[i].label && options.info[i].label !== '') {
				const value = (options.info[i].value ?? '?');

				if (undefined === options.info[i].url || options.info[i].url === '') {
					Manipulator.elementAppend(`<div class="system-settings-info__item" data-header="${(options.info[i].label ?? '?')}"><span>${value}</span></div>`, systemSettingsInfo);
				} else {
					Manipulator.elementAppend(`<div class="system-settings-info__item" data-header="${(options.info[i].label ?? '?')}"><span><a href="${options.info[i].url}" target="_top">${value}</a></span></div>`, systemSettingsInfo);
				}
			}
		}
	}
};

const addGrid = (options) => {
	if (undefined !== options.grid && isNumber(options.grid)) {
		const storageGrid = localStorage.getItem(`i-system-grid`);

		let columns = '';

		for (let i = 0; i < options.grid; i++) {
			columns += '<div class="col"></div>';
		}

		systemGrid = Manipulator.elementAppend(`
			<div aria-hidden="true" class="system system-grid" hidden>
				<div class="system-grid__content">
					<div class="row">${columns}</div>
				</div>
			</div>
		`);

		EventHandler.on(systemGrid, 'grid.show', (event) => {
			systemGrid.hidden = false;
			systemGrid.setAttribute('aria-hidden', 'true');

			localStorage.setItem(`i-system-grid`, '1');

			event.toggle.setAttribute('aria-pressed', 'true');
		});

		EventHandler.on(systemGrid, 'grid.hide', (event) => {
			systemGrid.hidden = true;

			systemGrid.removeAttribute('aria-hidden');

			localStorage.setItem(`i-system-grid`, '0');

			event.toggle.setAttribute('aria-pressed', 'false');
		});

		const toggle = Manipulator.elementAppend(`<button aria-pressed="true" type="button" class="system-info__grid">Grid</button>`, systemSettingsOptions);

		EventHandler.on(toggle, 'click', (event) => {
			const pressedAttr = event.target.getAttribute('aria-pressed') ?? '';

			event.preventDefault();
			event.stopPropagation();

			if (pressedAttr === 'true') {
				EventHandler.trigger(systemGrid, 'grid.hide', {
					toggle: event.target
				});

			} else {
				EventHandler.trigger(systemGrid, 'grid.show', {
					toggle: event.target
				});

				event.target.setAttribute('aria-pressed', 'true');
			}
		});

		EventHandler.trigger(systemGrid, `grid.${(!storageGrid || storageGrid === '0' ? 'hide' : 'show')}`, {
			toggle: toggle
		});
	}
};

// Initialization
document.addEventListener('DOMContentLoaded', () => {
	if (window.pageInstance && window.pageInstance.system) {
		const _o = extend({}, DEFAULTS, window.pageInstance.system);

		buildSystem(_o).then(async res => {
			await addGrid(_o);
			await addInfo(_o);

			if (systemToggle) {
				EventHandler.trigger(systemToggle, 'handleDisplay');
			}
		});
	}
});
